var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "yxtf-dialog",
        {
          attrs: {
            title: _vm.$t("pc_biz_lbl_joinlib" /** 加入知识库 */),
            visible: _vm.visible,
            "append-to-body": "",
            "close-on-click-modal": false,
            width: "520px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            closed: _vm.closed,
          },
        },
        [
          _vm.loading
            ? _c(
                "i",
                {
                  staticClass:
                    "yxtbiz-joinlib_loading pa right-top text-center",
                },
                [
                  _c("yxtf-svg", {
                    staticClass: "pa",
                    attrs: {
                      width: "20px",
                      height: "20px",
                      "icon-class": "loading",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "yxtf-form",
            {
              ref: "form",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "80px",
                "label-position": _vm.labelPosition,
              },
            },
            [
              _c(
                "yxtf-form-item",
                {
                  attrs: {
                    prop: "title",
                    label: _vm.$t("pc_biz_lbl_kngname" /** 知识名称 */),
                  },
                },
                [
                  _c("yxtf-input", {
                    attrs: {
                      maxlength: _vm.maxLen,
                      "show-word-limit": "",
                      placeholder: _vm.$t(
                        "pc_biz_lbl_kngnameplaceholder" /** 请输入知识名称 */
                      ),
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        $event.preventDefault()
                      },
                    },
                    model: {
                      value: _vm.ruleForm.title,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.ruleForm,
                          "title",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "ruleForm.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "yxtf-form-item",
                {
                  attrs: {
                    prop: "libId",
                    label: _vm.$t("pc_biz_lbl_lib" /** 知识库 */),
                  },
                },
                [
                  _c("LibSelect", {
                    ref: "libSelect",
                    attrs: {
                      "file-id": _vm.fileId,
                      "storage-type": _vm.storageType,
                    },
                    on: { change: _vm.libChange },
                  }),
                ],
                1
              ),
              _c(
                "yxtf-form-item",
                {
                  attrs: {
                    prop: "catalogId",
                    label: _vm.$t("pc_biz_lbl_folder" /** 文件夹 */),
                  },
                },
                [
                  _c("FolderSelect", {
                    ref: "folderSelect",
                    attrs: {
                      "lib-id": _vm.ruleForm.libId,
                      "has-create-permission": _vm.hasCreatePermission,
                    },
                    on: { add: _vm.addFolder },
                    model: {
                      value: _vm.ruleForm.catalogId,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "catalogId", $$v)
                      },
                      expression: "ruleForm.catalogId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "footer" },
            [
              _c("CancelButton", {
                on: {
                  click: function ($event) {
                    _vm.visible = false
                  },
                },
              }),
              _c(
                "yxtf-button",
                {
                  attrs: { type: "primary", loading: _vm.submiting },
                  on: { click: _vm.save },
                },
                [_vm._v(_vm._s(_vm.$t("pc_biz_core_btn_confirm")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("AddFolder", {
        ref: "add",
        attrs: { "label-position": _vm.labelPosition },
      }),
      _c(
        "yxtf-dialog",
        {
          attrs: {
            "padding-size": "small",
            visible: _vm.errorVisible,
            "append-to-body": "",
            "show-close": false,
            width: "400px",
            "close-on-click-modal": false,
            model: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.errorVisible = $event
            },
            closed: _vm.closed,
          },
        },
        [
          _c(
            "div",
            { staticClass: "yxtbiz-joinlib_flex yxtbiz-joinlib_errordialog" },
            [
              _c("i", {
                staticClass: "yxt-icon-warning yxtf-color-warning font-size-20",
              }),
              _c(
                "p",
                { staticClass: "yxtbiz-joinlib_flex1 text-26 lh22 break" },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "pc_biz_msg_nolib" /** 无法找到可加入的知识库，可联系管理员新建知识库或修改知识库存储方式。 */
                      )
                    )
                  ),
                ]
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "mt20 clearfix" },
            [
              _c(
                "yxtf-button",
                {
                  staticClass: "pull-right",
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.errorVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("pc_biz_core_btn_determine")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }